document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll(
    '.product__accordion details'
  );

  const instances = new Map();

  class SmoothAccordion {
    constructor(details) {
      this.details = details;
      this.summary = details.querySelector('summary');
      this.content = details.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;

      if (!this.summary || !this.content) return;

      this.summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (this.details.open) {
          this.close();
        } else {
          this.closeOtherAccordions();
          this.open();
        }
      });
    }

    closeOtherAccordions() {
      const container =
        this.details.closest('.product__info-container') ||
        document;

      const opened = container.querySelectorAll(
        '.product__accordion details[open]'
      );

      opened.forEach((details) => {
        if (details === this.details) return;

        const instance = instances.get(details);

        if (instance) {
          instance.close();
        } else {
          details.open = false;
        }
      });
    }

    open() {
      this.details.style.height =
        `${this.details.offsetHeight}px`;

      this.details.open = true;

      window.requestAnimationFrame(() => {
        this.expand();
      });
    }

    expand() {
      this.isExpanding = true;

      const startHeight =
        `${this.summary.offsetHeight}px`;

      const endHeight =
        `${this.details.scrollHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate(
        {
          height: [startHeight, endHeight]
        },
        {
          duration: 350,
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)'
        }
      );

      this.animation.onfinish = () => {
        this.onAnimationFinish(true);
      };

      this.animation.oncancel = () => {
        this.isExpanding = false;
      };
    }

    close() {
      this.isClosing = true;

      const startHeight =
        `${this.details.offsetHeight}px`;

      const endHeight =
        `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate(
        {
          height: [startHeight, endHeight]
        },
        {
          duration: 350,
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)'
        }
      );

      this.animation.onfinish = () => {
        this.onAnimationFinish(false);
      };

      this.animation.oncancel = () => {
        this.isClosing = false;
      };
    }

    onAnimationFinish(open) {
      this.details.open = open;

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;

      this.details.style.height = '';
    }
  }

  accordions.forEach((details) => {
    const instance = new SmoothAccordion(details);
    instances.set(details, instance);
  });
});